<template>
  <div class="search-sidebar">
    <div class="filter-group">
      <label for="free-search">Search</label>
      <input
        id="free-search"
        v-model="filters.freeSearch"
        placeholder="Enter keywords"
      />
    </div>
    <div class="filter-group">
      <label for="make">Make</label>
      <input id="make" v-model="filters.make" placeholder="Enter car make" />
    </div>
    <div class="filter-group">
      <label for="model">Model</label>
      <input id="model" v-model="filters.model" placeholder="Enter car model" />
    </div>
    <div class="filter-group">
      <label for="body-type">Body Type</label>
      <select id="body-type" v-model="filters.bodyType">
        <option value="">Select body type</option>
        <option value="sedan">Sedan</option>
        <option value="suv">SUV</option>
        <option value="convertible">Convertible</option>
        <option value="hatchback">Compact</option>
        <option value="coupe">Coupe</option>
        <option value="wagon">Wagon</option>
        <option value="van">Van</option>
      </select>
    </div>
    <div class="filter-group">
      <label for="year-from">Year</label>
      <input
        id="year-from"
        v-model="filters.yearFrom"
        type="number"
        placeholder="From"
      />
    </div>
    <div class="filter-group">
      <input
        id="year-to"
        v-model="filters.yearTo"
        type="number"
        placeholder="To"
      />
    </div>
    <div class="filter-group">
      <label for="price-from">Price</label>
      <input
        id="price-from"
        v-model="filters.priceFrom"
        type="number"
        placeholder="From"
      />
    </div>
    <div class="filter-group">
      <input
        id="price-to"
        v-model="filters.priceTo"
        type="number"
        placeholder="To"
      />
    </div>
    <div class="filter-group">
      <label for="fuel-type">Fuel Type</label>
      <select id="fuel-type" v-model="filters.fuelType">
        <option value="">Select fuel type</option>
        <option value="gasoline">Gasoline</option>
        <option value="diesel">Diesel</option>
        <option value="electric">Electric</option>
        <option value="hybrid">Hybrid</option>
        <option value="lpg">LPG</option>
        <option value="cng">CNG</option>
      </select>
    </div>
    <div class="filter-group">
      <label for="mileage-from">Mileage(km)</label>
      <input
        id="mileage-from"
        v-model="filters.mileageFrom"
        type="number"
        placeholder="From"
      />
    </div>
    <div class="filter-group">
      <input
        id="mileage-to"
        v-model="filters.mileageTo"
        type="number"
        placeholder="To"
      />
    </div>
    <div class="filter-group">
      <label for="transmission">Transmission</label>
      <select id="transmission" v-model="filters.transmission">
        <option value="">Select transmission</option>
        <option value="automatic">Automatic</option>
        <option value="manual">Manual</option>
      </select>
    </div>
    <div class="filter-group">
      <label for="color">Color</label>
      <input id="color" v-model="filters.color" placeholder="Enter color" />
    </div>
    <div class="filter-group">
      <label for="location">Location</label>
      <input
        id="location"
        v-model="filters.location"
        placeholder="Enter location"
      />
    </div>
    <button @click="applyFilters">Apply Filters</button>
  </div>
</template>

<script>
import { ref } from 'vue';

export default {
  name: 'SearchSidebar',
  emits: ['filter'],
  setup(_, { emit }) {
    const filters = ref({
      make: '',
      model: '',
      year: '',
      price: '',
    });

    const applyFilters = () => {
      emit('filter', { ...filters.value });
    };

    return {
      filters,
      applyFilters,
    };
  },
};
</script>

<style lang="scss" scoped>
.search-sidebar {
  padding: 6px;
  box-sizing: border-box;
  border: 1px solid #90caf9; // Light blue border
  display: flex;
  flex-direction: column;
  align-items: stretch;
  max-height: 100%;
  overflow-y: auto;
  border-radius: 6px;
}

.filter-group {
  margin-bottom: 6px;
}

.filter-group label {
  display: block;
  margin-bottom: 1px;
  font-size: 1rem;
  color: #1565c0; // Strong blue text
}

.filter-group input,
.filter-group select {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #90caf9; // Light blue border
  border-radius: 6px;
  font-size: 1.1rem;
  height: 40px;
  background-color: #f7fafd; // Soft white-blue background
  color: #1565c0; // Strong blue text
}

button {
  margin-top: 10px;
  padding: 8px 12px;
  background-color: #1976d2; // Blue button
  color: #ffffff; // White text for contrast
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1.2rem;
  box-shadow: 0 2px 8px rgba(33,150,243,0.08);
}

button:hover {
  background-color: #1565c0; // Slightly darker blue for hover
}

/* Ensure sufficient contrast for WCAG compliance */
.filter-group input:focus,
.filter-group select:focus,
button:focus {
  outline-offset: 2px;
}
</style>
